var TorsoBehavior = require('backbone-torso/modules/Behavior');

/**
 * This behavior adds a _renderIfDisplayed method to the view that will only call a render if the view is both active
 * and part of the currently displayed DOM.
 *
 * @class RenderIfDisplayedBehavior
 * @constructor
 */
module.exports = TorsoBehavior.extend({
  mixin: {
    /**
     * Renders the view only if it is active and part of the DOM.
     * @method _renderIfDisplayed
     * @private
     */
    _renderIfDisplayed: function() {
      if (this.view.isActive() && this.view.isAttached()) {
        this.view.render();
      }
    }
  }
});
